/**
 * Search — the screen the app did not have.
 *
 * `GET /api/catalog?q=` existed and was correct from the start; nothing called it. So the
 * only way to find a film by name was to guess which library it was in and scroll.
 *
 * The screen is now a wrapper: everything it used to do lives in `SearchPanel`, which the
 * desktop overlay mounts as well. This route stays because a route is the right shape for
 * the phone's tab bar, for a deep link, and for the television — a tab that opens an
 * overlay instead of a page is a lie about where you are, and the remote has no Escape.
 */
import { SearchPanel } from '../components/SearchPanel';

export function SearchPage() {
  return (
    <main>
      <SearchPanel />
    </main>
  );
}
